import { customAxios } from '../../common/customAxios';

export interface IReturnTodaySellTractorBumpStatus {
  todayBumpCount: number;
}

export const getTodaySellTractorBumpStatus = (): Promise<IReturnTodaySellTractorBumpStatus> => {
  return customAxios.get('/user-sell-tractor-bump/today-bump-status');
};
